import React from "react";

const Input = ({
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  className,
}) => {
  return (
    <div className="mb-4">
      {/* <label
        className="block text-gray-700 text-sm font-bold mb-1"
        htmlFor={label}
      >
        {label}
      </label> */}
      <input
        className={`${
          error ? "border-red-500" : "border-gray-300"
        } ${className}`}
        type={type || "text"}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
      />
      {error && <p className="text-red-500 text-sm mt-1 ml-5">{error}</p>}
    </div>
  );
};

export default Input;
